export const columns = [
  {
    label: '维度',
    align:'center',
    fixed: true,
    children: []
  },
  {
    label: '基础数据',
    align: 'center',
    fixed: true,
    width:'880px',
    children: [
      {
        label: '总新增',
        prop: 'installs',
        sortable: true,
      },
      {
        label: 'arpu',
        prop:'arpu',
      },
      {
        label: '推广单价',
        prop:'popCost',
      },
      {
        label: '新增单价',
        prop:'cresCost',
      },
      {
        label: '预估倍数',
        prop:'estimateTimes',
      },
      {
        label: '预测LT(360日)',
        prop:'p28_retentionDay360',
      },
      {
        label: '预估终身价值',
        prop:'userValue1',
      },
      {
        label: '预测LTV360日',
        prop:'userValue360',
      },
    ]
  },
  {
    label: '28日预测值(用于校验)',
    align:'center',
    children: [
      {
        label: '30日用户价值',
        prop:'userValue30'
      },
      {
        label: '60日用户价值',
        prop:'userValue60'
      },
      {
        label: '90日用户价值',
        prop:'userValue90'
      },
      {
        label: '120日用户价值',
        prop:'userValue120'
      },
      {
        label: '150日用户价值',
        prop:'userValue150'
      },
      {
        label: '180日用户价值',
        prop:'userValue180'
      },
      {
        label: '240日用户价值',
        prop:'userValue240'
      },
      {
        label: '300日用户价值',
        prop:'userValue300'
      },
      {
        label: '360日用户价值',
        prop:'userValue360'
      },
      {
        label: '30日LT',
        prop:'p28_retentionDay30'
      },
      {
        label: '60日LT',
        prop:'p28_retentionDay60'
      },
      {
        label: '90日LT',
        prop:'p28_retentionDay90'
      },
      {
        label: '120日LT',
        prop:'p28_retentionDay120'
      },
      {
        label: '150日LT',
        prop:'p28_retentionDay150'
      },
      {
        label: '180日LT',
        prop:'p28_retentionDay180'
      },
      {
        label: '240日LT',
        prop:'p28_retentionDay240'
      },
      {
        label: '300日LT',
        prop:'p28_retentionDay300'
      },
      {
        label: '360日LT',
        prop:'p28_retentionDay360'
      },
    ]
  }
]